// extracted by mini-css-extract-plugin
export default {"link":"burgerIconLink_link__RCoJP","description":"burgerIconLink_description__8GVZg","disactive":"burgerIconLink_disactive__yKrm2"};